import type { AxiosInstance } from 'axios';
import { injectable } from 'inversify';
import { Result } from 'services/Result';
import { IApiScheduleResponse } from '../../interfaces/team/IApiScheduleResponse';

@injectable()
export class ScheduleService {
  private axiosInstance: AxiosInstance;

  constructor(axiosInstance: AxiosInstance) {
    this.axiosInstance = axiosInstance;
  }

  GetGamesScheduledLocalForToday = async () => {
    const response = await this.axiosInstance.get<Result<IApiScheduleResponse[]>>('api/schedule/scheduleLocal/');
    if (response.data && !response.data.isError && response.data.data) {
      return response.data.data;
    }
    throw Error(`Failed to fetch schedule local: ${response.status}`);
  };

  GetGamesScheduledForToday = async () => {
    const response = await this.axiosInstance.get<Result<IApiScheduleResponse[]>>('api/schedule/schedule/');
    if (response.data && !response.data.isError && response.data.data) {
      return response.data.data;
    }
    throw Error(`Failed to fetch schedule: ${response.status}`);
  };
}
